import { Controller } from "@hotwired/stimulus"

// Handles load/refresh for the ranging review pane.
// Sets the turbo-frame src to trigger a fetch from the server.
export default class extends Controller {
  static values = { url: String }
  static targets = ["loadButton", "readyState", "loadingState"]

  load() {
    const frame = document.getElementById("ranging-review-content")
    if (!frame) return

    frame.src = this.urlValue

    if (this.hasLoadButtonTarget) {
      this.loadButtonTarget.disabled = true
    }
    if (this.hasReadyStateTarget) {
      this.readyStateTarget.style.display = "none"
    }
    if (this.hasLoadingStateTarget) {
      this.loadingStateTarget.style.display = "flex"
    }
  }
}
